export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/currency/state.js